import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Clock, Baby, Moon } from 'lucide-react';
export function UniqueMethod() {
  const phases = [{
    title: 'La pausa breve',
    icon: <Clock className="w-6 h-6 text-accent" data-id="element-134" />,
    delay: 0.1
  }, {
    title: 'La extensión gradual',
    icon: <Baby className="w-6 h-6 text-accent" data-id="element-135" />,
    delay: 0.2
  }, {
    title: 'La consolidación',
    icon: <Moon className="w-6 h-6 text-accent" data-id="element-136" />,
    delay: 0.3
  }];
  return <section className="py-24 bg-brown-dark text-cream relative overflow-hidden rounded-[3rem] mx-4 md:mx-8 my-12" data-id="element-137">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-138">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-accent rounded-full blur-3xl" data-id="element-139"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-brown rounded-full blur-3xl" data-id="element-140"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-141">
        <FadeIn data-id="element-142">
          <div className="text-center mb-16" data-id="element-143">
            <span className="text-accent font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-144">
              El Mecanismo Único
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-145">
              El Método de Micro-pausas Nocturnas
            </h2>
            <p className="text-xl text-cream/80 max-w-3xl mx-auto font-serif italic" data-id="element-146">
              Un enfoque diferente, diseñado para la realidad de una madre
              agotada.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-147">
          {phases.map((phase, index) => <FadeIn key={index} delay={phase.delay} direction="up" data-id="element-148">
              <div className="bg-white/5 border border-white/10 p-8 rounded-3xl backdrop-blur-sm text-center h-full flex flex-col items-center justify-center hover:bg-white/10 transition-colors" data-id="element-149">
                <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mb-6" data-id="element-150">
                  {phase.icon}
                </div>
                <h3 className="text-2xl font-serif font-bold text-accent mb-2" data-id="element-151">
                  Fase {index + 1}
                </h3>
                <p className="text-lg text-cream" data-id="element-152">{phase.title}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-153">
          <div className="bg-white/10 p-8 md:p-10 rounded-3xl backdrop-blur-md border border-white/20" data-id="element-154">
            <p className="text-lg md:text-xl leading-relaxed text-cream/90 text-center" data-id="element-155">
              Comienza con intervalos de espera muy cortos antes de intervenir,
              permitiendo que el bebé empiece a autorregularse. Es flexible, se
              adapta a la edad del bebé y respeta el nivel de cansancio de la
              madre. No es un enfoque rígido, sino un sistema adaptable que te
              guía noche a noche.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}